import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert';
import PropTypes from 'prop-types';
import { TitleBar, IconCheck, IconClose } from '../common/theme';
import { getCreateUserStatus, generatePassword, getCreateFeildStatus } from '../../ApiHelper';
import { toArray, removeDuplicates, removeArrayDuplicates, isObjectEmpty, padArray } from '../../Utils';
import Spinner from '../common/generic/Spinner';

const ImportUsersComp = ({pageState}) => {
    const [loginNameRadio, setLoginNameRadio] = useState('1');
    const [passwordsRadio, setPasswordsRadio] = useState('1');
    const [teacherRadio, setTeacherRadio] = useState('1');
    const [passwordsNumChars, setPasswordsNumChars] = useState(4);
    const [passwordsDefault, setPasswordsDefault] = useState('');
    const [useLetters, setUseLetters] = useState(true);
    const [useNumbers, setUseNumbers] = useState(true);
    const [csvData, setcsvData] = useState('');
    const [csvTable, setcsvTable] = useState([]);
    const [step, setStep] = useState('1');
    const [isSavingClasses, setIsSavingClasses] = useState(false);
    const [isSavingStudents, setIsSavingStudents] = useState(false);
    const [isWaitingForClassIDs, setIsWaitingForClassIDs] = useState(false);
    const [numErrors,setNumErrors] = useState(0);

    const [newStudents, setNewStudents] = useState([
        {name:'Teacher', login:'jamie', pass:'L9W3', type:'ok',
            students:[{name:'Jamie Whitten', login:'jamie', pass:'L9W3', type:'ok'}]
        }
    ]);

    const classColor = 'lightblue';
    const studentColor = '#BFBFFF';
    const loginColor = 'BFFFBF';
    const passwordColor = '#FFBFBF';

    const titleRow = <Row style={{fontWeight:'bold'}}>
        <Col style={{textAlign: 'left'}} xs='3'>Name</Col>
        <Col style={{textAlign: 'left'}} xs='3'>Username</Col>
        <Col style={{textAlign: 'left'}} xs='3'>Password</Col>
        <Col style={{textAlign: 'left'}} xs='3'>Problem</Col>
    </Row>;

    const handleLoadFileChange = event =>{
        let files = event.target.files;
        let customer = pageState.database['getCustomer'].data;
        var fr = new FileReader();
        fr.onload = function(e) {
            let fileContent = e.target.result;
            fileContent = fileContent.replace(/\r/gi, '');
            setcsvData(fileContent);

            setcsvTable(fileContent.split('\n').map(e=>e.split(',')));

            let getAllStudentsQuery = {
                params:customer.ID,
                func:'getAllStudentsForSchool',
              };    
            pageState.request(getAllStudentsQuery);            

        };
        fr.readAsText(files[0]);    
        setStep('2');
    };

    const buildHorizontalDataMin=(fileLines, errorCount)=>{
        let currentNumStudents = parseInt(pageState.database['getCustomer'].data['NumStudents']);
        let currentLimit = pageState.database['userLimit'];

        let importData = fileLines.map(classRec=>{
            let lineData = classRec.split(',');
            let className = lineData[0].trim();
            let allStudents = [];
            let classFound = toArray(pageState.database['getAllClasses'].data).find(e=>e.Classname === className);
            let classLogin = className;

            let nameParts = className.split(' ');
            if(loginNameRadio === '2') classLogin = nameParts[0];
            if(loginNameRadio === '3') classLogin = nameParts[nameParts.length-1];
            if(loginNameRadio === '4') classLogin = nameParts[0]+((nameParts.length > 1) ? nameParts[nameParts.length-1].charAt(0) : '');            

            let classPass =  generatePassword(passwordsNumChars,useLetters,useNumbers);
            classPass = (passwordsRadio === '2') ? passwordsDefault : classPass;  
            classPass = (passwordsRadio === '3') ? 'pass1' : classPass;              

            let classID = '';
            if(classFound){                
                allStudents = toArray(pageState.database['getAllStudentsForSchool'].data).filter(e=>e.ClassID===classFound.ClassID);
                classLogin = classFound.Username;
                classPass = classFound.Password;
                classID = classFound.ClassID;
            }

            let statusName = getCreateUserStatus('Name',className,true,[]);
            let statusLogin = getCreateUserStatus('Username',classLogin,true,[]);
            let statusPass = getCreateFeildStatus('Password',classPass,true);
            let statusTest = (statusName.error)?statusName.error:(statusLogin.error)?statusLogin.error:(statusPass.error)?statusPass.error:'ok';
            let classStatus = (classID==='')?'ok':'Merging Class';
            classStatus = (statusTest==='ok')?classStatus:statusTest;
            if(statusTest !== 'ok') errorCount.count++;     

            lineData.shift(); 
            let studentNames = lineData;
            let studentLines = studentNames
                .map(e=>e.trim()) // remove white space
                .filter(e=>e) // remove empty lines
                .filter((val,id,array) => array.indexOf(val) == id) // remove duplicates
                .map(name=>{ // add passwords and logins

                    let pass = generatePassword(passwordsNumChars,useLetters,useNumbers);
                    pass = (passwordsRadio === '2') ? passwordsDefault : pass;  
                    pass = (passwordsRadio === '3') ? '' : pass;  

                    let login = name;
                    let nameParts = name.split(' ');
                    if(loginNameRadio === '2') login = nameParts[0];
                    if(loginNameRadio === '3') login = nameParts[nameParts.length-1];
                    if(loginNameRadio === '4') login = nameParts[0]+((nameParts.length > 1) ? nameParts[nameParts.length-1].charAt(0) : '');

                    let statusName = getCreateUserStatus('Name',name,true,allStudents.map(e=>e.Name));
                    let statusLogin = getCreateUserStatus('Username',login,true,allStudents.map(e=>e.CompareName));
                    let statusPass = getCreateFeildStatus('Password',pass,false);
                    let status = (statusName.error)?statusName.error:(statusLogin.error)?statusLogin.error:(statusPass.error)?statusPass.error:'ok';

                    if(classStatus!=='ok' && classStatus!=='Merging Class')
                    status = 'Fix class before importing';

                    if(status === 'ok') currentNumStudents++;
                    if(currentNumStudents > currentLimit && currentLimit!==-1){
                        if(status === 'ok') 
                            status = 'Exceeded Limit';
                    }

                    if(status !== 'ok') errorCount.count++;
                    return {name, login, pass, type:status};
                }
            );
            // find duplicate login names
            let loginNames = studentLines.map(e=>e.login).filter((val,id,array) => array.indexOf(val) != id) ;
            studentLines = studentLines.map(studentRec=>{ // give an error for duplicate login names
                if(loginNames.indexOf(studentRec.login) > -1)
                    studentRec.type ='Username already taken';
                return studentRec;
            });        
            return {classID, name:className, login:classLogin, pass:classPass, type: classStatus, students:studentLines};
        });
        return importData;
    };

    const buildVerticalDataMin=(fileLines, errorCount)=>{
        let classList = fileLines[0].split(',');
        let currentNumStudents = parseInt(pageState.database['getCustomer'].data['NumStudents']);
        let currentLimit = pageState.database['userLimit'];

        let classData = classList            
            .map(e=>e.trim()) // remove white space
            .filter((val,id,array) => array.indexOf(val) == id) // remove duplicates
            .map(classRec=>{
                let className = classRec;
                let classFound = toArray(pageState.database['getAllClasses'].data).find(e=>e.Classname === className);
                let classLogin = className;
                let allStudents = [];
                let nameParts = className.split(' ');
                if(loginNameRadio === '2') classLogin = nameParts[0];
                if(loginNameRadio === '3') classLogin = nameParts[nameParts.length-1];
                if(loginNameRadio === '4') classLogin = nameParts[0]+((nameParts.length > 1) ? nameParts[nameParts.length-1].charAt(0) : '');            
     
                let classPass =  generatePassword(passwordsNumChars,useLetters,useNumbers);
                classPass = (passwordsRadio === '2') ? passwordsDefault : classPass;  
                classPass = (passwordsRadio === '3') ? 'pass1' : classPass;              
     
                let classID = '';
                if(classFound){                
                    allStudents = toArray(pageState.database['getAllStudentsForSchool'].data).filter(e=>e.ClassID===classFound.ClassID);
                    classLogin = classFound.Username;
                    classPass = classFound.Password;
                    classID = classFound.ClassID;
                }

                let statusName = getCreateUserStatus('Name',className,true,[]);
                let statusLogin = getCreateUserStatus('Username',classLogin,true,[]);
                let statusPass = getCreateFeildStatus('Password',classPass,true);
                let statusTest = (statusName.error)?statusName.error:(statusLogin.error)?statusLogin.error:(statusPass.error)?statusPass.error:'ok';
                let status = (classID==='')?'ok':'Merging Class';
                status = (statusTest==='ok')?status:statusTest;
                if(statusTest !== 'ok') errorCount.count++;

                return {classID, name:className, login:classLogin, pass:classPass, type: status, allStudents, students:[]};  
            });

        fileLines.shift();
        fileLines.forEach(line=>{
            let studentNames = line.split(',');
            studentNames.map(e=>e.trim()) // remove white space
                        .forEach((name,i)=>{ // add passwords and logins 
                            if(name.length===0) return;
                            if(!classData[i]) return;
                            
                            let pass = generatePassword(passwordsNumChars,useLetters,useNumbers);
                            pass = (passwordsRadio === '2') ? passwordsDefault : pass;  
                            pass = (passwordsRadio === '3') ? '' : pass;  
        
                            let login = name;
                            let nameParts = name.split(' ');
                            if(loginNameRadio === '2') login = nameParts[0];
                            if(loginNameRadio === '3') login = nameParts[nameParts.length-1];
                            if(loginNameRadio === '4') login = nameParts[0]+((nameParts.length > 1) ? nameParts[nameParts.length-1].charAt(0) : '');
        
                            let statusName = getCreateUserStatus('Name',name,true,classData[i].allStudents.map(e=>e.Name));
                            let statusLogin = getCreateUserStatus('Username',login,true,classData[i].allStudents.map(e=>e.CompareName));
                            let statusPass = getCreateFeildStatus('Password',pass,false);
                            let status = (statusName.error)?statusName.error:(statusLogin.error)?statusLogin.error:(statusPass.error)?statusPass.error:'ok';
        
                            if(classData[i].type!=='ok' && classData[i].type!=='Merging Class')
                                status = 'Fix class before importing';

                            if(status === 'ok') currentNumStudents++;
                            if(currentNumStudents > currentLimit && currentLimit!==-1){
                                if(status === 'ok') 
                                    status = 'Exceeded Limit';
                            }                                

                            if(status !== 'ok') errorCount.count++;
                            classData[i].students.push({name, login, pass, type:status});
                        }
                    );     
                }); 

        // remove duplicates
        classData.forEach(classRec=>classRec.students = removeDuplicates(classRec.students,'name'));

        // find duplicate login names
        classData.forEach(classRec=>{
            let loginNames = classRec.students.map(e=>e.login).filter((val,id,array) => array.indexOf(val) != id) ;
            classRec.students = classRec.students.map(studentRec=>{ // give an error for duplicate login names
                if(loginNames.indexOf(studentRec.login) > -1)
                    studentRec.type ='Username already taken';
                return studentRec;
            });
        });
        console.log('classData',classData);
        return classData;
   };

    const buildHorizontalData=(fileLines, errorCount)=>{
        return fileLines.map(classRec=>{
            let currentNumStudents = parseInt(pageState.database['getCustomer'].data['NumStudents']);
            let currentLimit = pageState.database['userLimit'];
            let lineData = classRec.split(',');
            let className = lineData[0].trim();
            let allStudents = [];
            let classFound = toArray(pageState.database['getAllClasses'].data).find(e=>e.Classname === className);
            let classLogin = className;
            let classPass =  generatePassword(passwordsNumChars,useLetters,useNumbers);

            let classID = '';
            if(classFound){                
                allStudents = toArray(pageState.database['getAllStudentsForSchool'].data).filter(e=>e.ClassID===classFound.ClassID);
                classLogin = classFound.Username;
                classPass = classFound.Password;
                classID = classFound.ClassID;
            }

            let statusName = getCreateUserStatus('Name',className,true,[]);
            let statusLogin = getCreateUserStatus('Username',classLogin,true,[]);
            let statusPass = getCreateFeildStatus('Password',classPass,true);
            let statusTest = (statusName.error)?statusName.error:(statusLogin.error)?statusLogin.error:(statusPass.error)?statusPass.error:'ok';
            let classStatus = (classID==='')?'ok':'Merging Class';
            classStatus = (statusTest==='ok')?classStatus:statusTest;
            if(statusTest !== 'ok') errorCount.count++;            

            lineData.shift(); 
            let combinedIndex = 0;
            let studentData = lineData.reduce((acc, columnData, i)=>{
                if(i%3===0) acc[combinedIndex]={name:columnData.trim()};
                if(i%3===1) acc[combinedIndex].login=columnData.trim();
                if(i%3===2) acc[combinedIndex++].pass=columnData.trim();
                return acc;
            },[]);

            studentData = studentData
                .map(studRec=>{
                    let statusName = getCreateUserStatus('Name',studRec.name,true,allStudents.map(e=>e.Name));
                    let statusLogin = getCreateUserStatus('Username',studRec.login,true,allStudents.map(e=>e.CompareName));
                    let statusPass = getCreateFeildStatus('Password',studRec.pass,false);
                    let status = (statusName.error)?statusName.error:(statusLogin.error)?statusLogin.error:(statusPass.error)?statusPass.error:'ok';

                    if(classStatus!=='ok' && classStatus!=='Merging Class')
                        status = 'Fix class before importing';

                    if(status === 'ok') currentNumStudents++;
                    if(currentNumStudents > currentLimit && currentLimit!==-1){
                        if(status === 'ok') 
                            status = 'Exceeded Limit';
                    }  

                    if(status !== 'ok') 
                        if(!(studRec.name==='' && studRec.login ==='' && studRec.pass === '')) // ignore missing records
                            errorCount.count++;  
                    return {...studRec, type:status};
                }
            );           

            // remove empty records
            studentData = studentData.filter(val => !(val.name==='' && val.login ==='' && val.pass === ''));
            // find duplicate login names
            let loginNames = studentData.map(e=>e.login).filter((val,id,array) => array.indexOf(val) != id) ;
            studentData = studentData.map(studentRec=>{ // give an error for duplicate login names
                if(loginNames.indexOf(studentRec.login) > -1)
                    studentRec.type ='Username already taken';
                return studentRec;
            }); 
            return {classID, name:className, login:classLogin, pass:classPass, type: classStatus, students:studentData};
        });
    };

    const buildHorizontalCollectionData=(fileLines, errorCount)=>{
        let classList = fileLines.map(line=>line.split(',')[0]);
        classList = removeArrayDuplicates(classList);
        let currentNumStudents = parseInt(pageState.database['getCustomer'].data['NumStudents']);
        let currentLimit = pageState.database['userLimit'];
        let classData = classList            
            .map(e=>e.trim()) // remove white space
            .map(classRec=>{
                let className = classRec.trim();
                let classFound = toArray(pageState.database['getAllClasses'].data).find(e=>e.Classname === className);
                let allStudents = [];
                

                let classLogin = fileLines.reduce((acc, line, i)=>{
                    let classParts = padArray(line.split(','), 6, '');
                    let checkName = classParts[0].trim();
                    let loginName = classParts[1].trim();
                    if(checkName === className && acc==='') 
                        acc = loginName;
                    return acc;
                },'');

                let classPass = fileLines.reduce((acc, line, i)=>{
                    let classParts = padArray(line.split(','), 6, '');
                    let checkName = classParts[0];
                    let password = classParts[2];
                    if(checkName === className && acc==='') 
                        acc = password;
                    return acc;
                },'');

                let classID = '';
                if(classFound){                
                    allStudents = toArray(pageState.database['getAllStudentsForSchool'].data).filter(e=>e.ClassID===classFound.ClassID);
                    classLogin = classFound.Username;
                    classPass = classFound.Password;
                    classID = classFound.ClassID;
                }

                let statusClassName = getCreateUserStatus('Name',className,true,[]);
                let statusClassLogin = getCreateUserStatus('Username',classLogin,true,[]);
                let statusClassPass = getCreateFeildStatus('Password',classPass,true);
                let statusClassTest = (statusClassName.error)?statusClassName.error:(statusClassLogin.error)?statusClassLogin.error:(statusClassPass.error)?statusClassPass.error:'ok';
                let classStatus = (classID==='')?'ok':'Merging Class';
                classStatus = (statusClassTest==='ok')?classStatus:statusClassTest;
                if(statusClassTest !== 'ok') errorCount.count++;

                let students = fileLines.reduce((acc, line, i)=>{
                    let lineParts = padArray(line.split(','), 6, '');
                    let checkName = lineParts[0];

                    let student = {};
                    if(checkName === className){ 
                        student.name = lineParts[3].trim();
                        student.login = lineParts[4].trim();
                        student.pass = lineParts[5].trim();

                        let statusName = getCreateUserStatus('Name',student.name,true,allStudents.map(e=>e.Name));
                        let statusLogin = getCreateUserStatus('Username',student.login,true,allStudents.map(e=>e.CompareName));
                        let statusPass = getCreateFeildStatus('Password',student.pass,false);
                        let status = (statusName.error)?statusName.error:(statusLogin.error)?statusLogin.error:(statusPass.error)?statusPass.error:'ok';

                        if(classStatus!=='ok' && classStatus!=='Merging Class')
                            status = 'Fix class before importing';

                        if(status === 'ok') currentNumStudents++;
                        if(currentNumStudents > currentLimit && currentLimit!==-1){
                            if(status === 'ok') 
                                status = 'Exceeded Limit';
                        }  
                        if(status !== 'ok') errorCount.count++;
                        student.type = status;
                    }
                    if(!isObjectEmpty(student))
                        acc.push(student);
                    return acc;
                },[]);

                return {classID, name:className, login:classLogin, pass:classPass, type:classStatus, allStudents, students};  
            });

                    // remove duplicates
        classData.forEach(classRec=>classRec.students = removeDuplicates(classRec.students,'name'));

        // find duplicate login names
        classData.forEach(classRec=>{
            let loginNames = classRec.students.map(e=>e.login).filter((val,id,array) => array.indexOf(val) != id) ;
            classRec.students = classRec.students.map(studentRec=>{ // give an error for duplicate login names
                if(loginNames.indexOf(studentRec.login) > -1){
                    studentRec.type ='Username already taken';
                    errorCount.count++;
                }
                return studentRec;
            });
        });

        return classData;
    };

    const buildVerticalData=(fileLines, errorCount)=>{
        let classList = fileLines[0].split(',');
        let currentNumStudents = parseInt(pageState.database['getCustomer'].data['NumStudents']);
        let currentLimit = pageState.database['userLimit'];
        let classData = classList            
            .map(e=>e.trim()) // remove white space
            .filter((val,id,array) => array.indexOf(val) == id) // remove duplicates
            .map(classRec=>{
                let className = classRec;
                let classFound = toArray(pageState.database['getAllClasses'].data).find(e=>e.Classname === className);
                let classLogin = className;
                let allStudents = [];
                classLogin = className;
     
                let classPass =  generatePassword(passwordsNumChars,useLetters,useNumbers);
                classPass = (passwordsRadio === '2') ? passwordsDefault : classPass;  
                classPass = (passwordsRadio === '3') ? 'pass1' : classPass;              
     
                let classID = '';
                if(classFound){                
                    allStudents = toArray(pageState.database['getAllStudentsForSchool'].data).filter(e=>e.ClassID===classFound.ClassID);
                    classLogin = classFound.Username;
                    classPass = classFound.Password;
                    classID = classFound.ClassID;
                }

                let statusName = getCreateUserStatus('Name',className,true,[]);
                let statusLogin = getCreateUserStatus('Username',classLogin,true,[]);
                let statusPass = getCreateFeildStatus('Password',classPass,true);
                let statusTest = (statusName.error)?statusName.error:(statusLogin.error)?statusLogin.error:(statusPass.error)?statusPass.error:'ok';
                let status = (classID==='')?'ok':'Merging Class';
                status = (statusTest==='ok')?status:statusTest;
                if(statusTest !== 'ok') errorCount.count++;

                return {classID, name:className, login:classLogin, pass:classPass, type:status, allStudents, students:[]};  
            });

        let studCnt = 0;
        fileLines.shift();
        fileLines.forEach((line,i_line)=>{
            let lineParts = line.split(',');
            if(i_line %3 === 0){
                lineParts.forEach((name,i)=>{ // add passwords and logins
                    if(!classData[i]) return;

                    if(name && name.trim() !== '')
                        classData[i].students[studCnt]={name:name.trim()};
                });     
            }
            if(i_line %3 === 1){
                lineParts.forEach((login,i)=>{ // add passwords and logins
                    if(!classData[i]) return;

                    if(classData[i].students[studCnt])
                        classData[i].students[studCnt].login = login.trim();
                });
            }      
            if(i_line %3 === 2){
                lineParts.forEach((password,i)=>{ // add passwords and logins
                    if(!classData[i]) return;
                    if(!classData[i].students[studCnt]) return;

                    classData[i].students[studCnt].pass = password.trim();

                    let statusName = getCreateUserStatus('Name',classData[i].students[studCnt].name,true,classData[i].allStudents.map(e=>e.Name));
                    let statusLogin = getCreateUserStatus('Username',classData[i].students[studCnt].login,true,classData[i].allStudents.map(e=>e.CompareName));
                    let statusPass = getCreateFeildStatus('Password',classData[i].students[studCnt].pass,false);
                    let status = (statusName.error)?statusName.error:(statusLogin.error)?statusLogin.error:(statusPass.error)?statusPass.error:'ok';

                    if(classData[i].type!=='ok' && classData[i].type!=='Merging Class')
                        status = 'Fix class before importing';

                    if(status === 'ok') currentNumStudents++;
                    if(currentNumStudents > currentLimit && currentLimit!==-1){
                        if(status === 'ok') 
                            status = 'Exceeded Limit';
                    }  
                    if(status !== 'ok') errorCount.count++;
                    classData[i].students[studCnt].type = status;
                });
                studCnt++;
            }  
        });

        // remove duplicates
        classData.forEach(classRec=>classRec.students = removeDuplicates(classRec.students,'name'));

        // find duplicate login names
        classData.forEach(classRec=>{
            let loginNames = classRec.students.map(e=>e.login).filter((val,id,array) => array.indexOf(val) != id) ;
            classRec.students = classRec.students.map(studentRec=>{ // give an error for duplicate login names
                if(loginNames.indexOf(studentRec.login) > -1)
                    studentRec.type ='Username already taken';
                return studentRec;
            });
        });

        return classData;
    };

    const verifyClicked = () =>{
         
        // convert the imported file into an array of classLines
        let fileLines = csvData
            .split('\n')
            .map(e=>e.trim()) 
            .filter(e=>e);
        
        let errorCount = {count:0};
        let classData = {};
        if(teacherRadio==='1') classData = buildHorizontalDataMin(fileLines, errorCount);
        if(teacherRadio==='2') classData = buildHorizontalCollectionData(fileLines, errorCount);
        if(teacherRadio==='3') classData = buildHorizontalData(fileLines, errorCount);
        if(teacherRadio==='4') classData = buildVerticalDataMin(fileLines, errorCount);
        if(teacherRadio==='6') classData = buildVerticalData(fileLines, errorCount);
        
        let loginNames = classData.map(e=>e.login).filter((val,id,array) => array.indexOf(val) != id);
        let names = classData.map(e=>e.name).filter((val,id,array) => array.indexOf(val) != id);

        // give an error for duplicate login names
        classData = classData.map(classRec=>{
            if(classRec.type!=='ok' && classRec.type!=='Merging Class') return classRec;

            if(loginNames.indexOf(classRec.login) > -1)
                classRec.type ='Username already taken';
            
            if(names.indexOf(classRec.name) > -1)
                classRec.type ='Name already taken';
            
            if(classRec.type!=='ok' && classRec.type!=='Merging Class'){
                errorCount.count ++;
                classRec.students = classRec.students.map(studRec=>{
                    if(studRec.type ==='ok'){
                        errorCount.count ++;
                        studRec.type='Fix class before importing'; 
                    }
                    return studRec;
                });
            }

            return classRec;
        }); 

        setNumErrors(errorCount.count);

        setNewStudents(classData);
        setStep('4');
    };

    const chooseOrient=()=>{
        if(teacherRadio==='1') setStep('3');
        if(teacherRadio==='2') verifyClicked();
        if(teacherRadio==='3') verifyClicked();
        if(teacherRadio==='4') setStep('3');
        if(teacherRadio==='6') verifyClicked();
    };

    const saveClasses=()=>{        
        let classesToSave = newStudents.filter(e=> e.type==='ok');
        let saveChanges = [];
        classesToSave.forEach((classRec, i) => {         
            let {name, login, pass, type} = classRec;
            if(type!=='ok') return; // only save the classes that are ok to save

            let prevQuery = (i!=0) ? saveChanges[i-1] : 'undefinded';
            let schoolID = pageState.database['getCustomer'].data['ID'];

            let query = {
                params: `${schoolID}~${name}~${pass}~default~None~N~N~N~0~80~${login}`,
                altName: 'importClass',
                func:'addClass',
            };
            if(prevQuery !== 'undefinded')
                query.nextRequest = prevQuery;
            saveChanges.push(query);
        });

        // create a link list of save changes querys for saving to the database
        if(saveChanges.length > 0){
            setIsSavingClasses(true);
            let counter = 1;
            saveChanges = saveChanges.map((query,i)=>{
                let prevQuery = (i!=0) ? saveChanges[i-1] : 'undefinded';
                if(prevQuery !== 'undefinded'){
                    counter++;
                    query.nextRequest = prevQuery;
                }
                return query;
            });
            let saveChainedChanges = saveChanges[saveChanges.length-1];
            saveChainedChanges.numQueries = counter;

            let currentNumClasses = parseInt(pageState.database['getCustomer'].data['NumClasses']);
            pageState.database['getCustomer'].data['NumClasses'] = (currentNumClasses + counter)+'';                        
            // pass the link list of saved changes into the database
            pageState.request(saveChainedChanges); 
        }
        else{
            setIsSavingClasses(true);
            // if there are classes but none of them are new then pretend to save the classes
            if(newStudents.length >0){
                pageState.internalUpdate('queryCount',-1);
            }
        } 
    };

    const saveStudents=(studentList)=>{
        setIsSavingStudents(true);
        let saveChanges = [];
        let i = 0;
        studentList.forEach((classRec) => {  
            classRec.students.forEach((studRec) => {         
                let {name, login, pass, type} = studRec;
                if(type!=='ok') return; // only save the students that are ok to save

                let prevQuery = (i!=0) ? saveChanges[i-1] : 'undefinded';
                let schoolID = pageState.database['getCustomer'].data['ID'];
                let classID = classRec.classID;

                let query = {
                    params: `${schoolID}~${classID}~${name}~${login}~${pass}~0~0`,
                    altName: 'importStudent',
                    func:'addStudent', 
                };
                if(prevQuery !== 'undefinded')
                    query.nextRequest = prevQuery;
                saveChanges.push(query);
                i++;                                
            });
        });

        // create a link list of save changes querys for saving to the database
        if(saveChanges.length > 0){
            setIsSavingStudents(true);
            let counter = 1;
            saveChanges = saveChanges.map((query,i)=>{
                let prevQuery = (i!=0) ? saveChanges[i-1] : 'undefinded';
                if(prevQuery !== 'undefinded'){
                    counter++;
                    query.nextRequest = prevQuery;
                }
                return query;
            });
            let saveChainedChanges = saveChanges[saveChanges.length-1];
            saveChainedChanges.numQueries = counter;

            let currentNumStudents = parseInt(pageState.database['getCustomer'].data['NumStudents']);
            pageState.database['getCustomer'].data['NumStudents'] = (currentNumStudents + counter)+'';

            // pass the link list of saved changes into the database
            pageState.request(saveChainedChanges); 
        } 
    };

    useEffect(()=>{
        if(pageState.showImportUsersComp)
            setStep('1');
    },[pageState.showImportUsersComp]);
    // Check when saving has completed by wating for database.queryCount to become 0
    // UPDATES - database.queryCount changes -&&- only when saving
    useEffect(()=>{

        if(isSavingStudents){ // check to see if done saving students
            if(pageState.database.queryCount <= 0){
                setIsSavingClasses(false);
                setIsSavingStudents(false);
                pageState.showClassScreen();
            }
        } 
        if(isSavingClasses){ // check to see if done saving classes
            if(pageState.database.queryCount <= 0){
                setIsSavingClasses(false);

                // check to see if students need saving
                let numStudentsToSave = 0;                
                newStudents.forEach(classRec=>{
                    if(classRec.type==='ok' || classRec.type==='Merging Class') // don't include classes with errors
                        classRec.students.forEach(studRec=>{
                            if(studRec.type==='ok')
                                numStudentsToSave++;
                        });
                });

                // grab all the classIDs again to add them to the new classes with students
                let query = {
                    params: pageState.database['getCustomer'].data['ID'],
                    func:'getAllClasses',
                    };
                pageState.request(query); 

                if(numStudentsToSave===0){ // only save the classes and leave
                    pageState.showClassScreen();
                    return;
                }

                setIsWaitingForClassIDs(true);
            }
        }       
    },[pageState.database.queryCount]);    

    useEffect(()=>{ // recieve new list of classes to find all the new class IDs
        if(pageState.database['getAllClasses'] && pageState.database['getAllClasses'].isLoaded && isWaitingForClassIDs){
            let newStudentWithClassIDs = newStudents.map(classRec=>{
                // if there is an error in the class then dont import the class
                if(classRec.type!=='ok' && classRec.type!=='Merging Class') return classRec;

                if(classRec.classID===''){
                    let findClass = toArray(pageState.database['getAllClasses'].data).find(e=>e.Classname===classRec.name);
                    classRec.classID=findClass.ClassID;
                }
                return classRec;
            });

            setIsWaitingForClassIDs(false);
            saveStudents(newStudentWithClassIDs);
        }
    },[pageState.database['getAllClasses']]);


    if(isSavingStudents || isSavingClasses)
        return <> <Spinner/><center><h1>Processing...({pageState.database['queryCount']})</h1></center></>;

    return ((!pageState.showImportUsersComp)?<></>:
    <div style={{paddingTop:'20px'}}>
        <Alert variant='warning'>
            <h4> Import Instructions </h4>
            <p> It is recommended to for schools with many students and classes to import their data from a file.  <a href="https://essentialskills.com/importing" rel="noopener noreferrer" target="_blank"> Click here for instructions </a></p>
        </Alert>
        <br/>
             
        <TitleBar>
            <Col style={{textAlign: 'left', color: 'white' }} xs='8'><h3>Importing Classes and students from a CSV file:</h3></Col>
            <Col xs='4'>
                <span className={'pull-right'}>
                    <Button variant="danger" onClick={()=>{setStep('1'); setcsvData(''); setcsvTable([]); pageState.showAddUserScreen('Class');}}>Cancel</Button> &nbsp;
                </span>
            </Col>
        </TitleBar> 

        <br/>
        {(step==='1') &&
            <Row><Col xs='12'>
                <Alert variant='warning'>            
                    <h4> Step 1 ) </h4>
                    <p> Load a comma delimited file that contains only the classes and students you want to import into the database.</p>
                    <span><input onChange={handleLoadFileChange} type="file" id="files" name="files[]" multiple /></span>
                </Alert>    
            </Col></Row>}                        

        {(step==='2') && <>
            <Row><Col xs='12'>
                <Alert variant='warning'> 
                    <h4> Step 2 ) </h4>
                    <p>The first 5 rows and columns of your file is displayed in the table below. Please check for any mistakes before continuing. <strong>Make sure you see the data starting on the first row.</strong> </p>
                    <p>Select the option that shows how your file is formatted using the color codes below.</p>
                    <p><strong>Row Options</strong></p>
                    <label><input type="radio" checked={teacherRadio === '1'} onChange={(e)=>setTeacherRadio(e.target.value)} value="1" name="optradio"/> Option 1</label>&nbsp;&nbsp;
                    {/* <label><input type="radio" checked={teacherRadio === '2'} onChange={(e)=>setTeacherRadio(e.target.value)} value="2" name="optradio"/> Option 2</label>&nbsp;&nbsp; */}
                    <label><input type="radio" checked={teacherRadio === '3'} onChange={(e)=>setTeacherRadio(e.target.value)} value="3" name="optradio"/> Option 2 (Class per row)</label>&nbsp;&nbsp;
                    <label><input type="radio" checked={teacherRadio === '2'} onChange={(e)=>setTeacherRadio(e.target.value)} value="2" name="optradio"/> Option 3</label>&nbsp;&nbsp;
                    
                    <p><strong>Column Options</strong></p>
                    <label><input type="radio" checked={teacherRadio === '4'} onChange={(e)=>setTeacherRadio(e.target.value)} value="4" name="optradio"/> Option 4</label>&nbsp;&nbsp;
                    {/* <label><input type="radio" checked={teacherRadio === '5'} onChange={(e)=>setTeacherRadio(e.target.value)} value="5" name="optradio"/> Option 5</label>&nbsp;&nbsp; */}
                    <label><input type="radio" checked={teacherRadio === '6'} onChange={(e)=>setTeacherRadio(e.target.value)} value="6" name="optradio"/> Option 5</label>&nbsp;&nbsp;
                </Alert>    
            </Col></Row>

            <span style={{width:'30px',height:'30px', backgroundColor:classColor, borderStyle: 'solid', borderWidth: '1px'}}>&nbsp;&nbsp;&nbsp;&nbsp;</span> Class Name &nbsp;
            <span style={{width:'30px',height:'30px', backgroundColor:studentColor, borderStyle: 'solid', borderWidth: '1px'}}>&nbsp;&nbsp;&nbsp;&nbsp;</span> Student Name &nbsp;
            <span style={{width:'30px',height:'30px', backgroundColor:loginColor, borderStyle: 'solid', borderWidth: '1px'}}>&nbsp;&nbsp;&nbsp;&nbsp;</span> Username &nbsp;
            <span style={{width:'30px',height:'30px', backgroundColor:passwordColor, borderStyle: 'solid', borderWidth: '1px'}}>&nbsp;&nbsp;&nbsp;&nbsp;</span> Password &nbsp;<br/>
            <hr/>
            <table width='100%'><tbody>
            {(teacherRadio === '1') &&    
                csvTable.map((dataLine, i) => 
                (i < 6 ) && <ImportRow1 key={i} dataLine={dataLine} />
            )}
            {(teacherRadio === '2') &&    
                csvTable.map((dataLine, i) => 
                (i < 6 ) && <ImportRow2 key={i} dataLine={dataLine} />
            )}
            {(teacherRadio === '3') &&    
                csvTable.map((dataLine, i) => 
                (i < 6 ) && <ImportRow3 key={i} dataLine={dataLine} />
            )}
            {(teacherRadio === '4') &&    
                csvTable.map((dataLine, i) => 
                (i < 6 ) && <ImportRow4 key={i} dataLine={dataLine} i={i} />
            )}
            {(teacherRadio === '5') &&    
                csvTable.map((dataLine, i) => 
                (i < 6 ) && <ImportRow5 key={i} dataLine={dataLine} i={i} />
            )}
            {(teacherRadio === '6') &&    
                csvTable.map((dataLine, i) => 
                (i < 6 ) && <ImportRow6 key={i} dataLine={dataLine} i={i} />
            )}

            </tbody>
            </table>
            <br/>
            <Row><Col xs='12'><Button onClick={()=>setStep('1')} variant='danger'>Back</Button> <Button onClick={chooseOrient} variant='success' >Choose</Button></Col></Row>
            <br/>
        </>}
        {(step==='3') && <>
            <Row><Col xs='12'>
                <Alert variant='warning'>
                    <h4> Step 3 ) </h4>
                    <p> Now choose how to generate the student usernames and passwords. <br/><br/><strong>Note:</strong> <i>Students in the same class can not share the same student name or login name. Duplicate login names will get a altered with a suffix.</i></p>
                </Alert>    
            </Col></Row>
            <Row>
                <Col xs='4'>
                    <TitleBar>
                        <Col style={{textAlign: 'left', color: 'white' }} xs='8'><h3>Usernames</h3></Col>
                    </TitleBar>

                    <Row style={{height:'228px',backgroundColor:'#efefff', borderStyle: 'solid', borderWidth: '1px', borderColor: '#bfbfbf', paddingLeft:'10px'}}>
                    <Col xs='12'>
                        <Row><Col xs='12'>&nbsp;</Col></Row>
                        <Row><Col xs='12'><label><input checked={loginNameRadio === '1'} onChange={(e)=>setLoginNameRadio(e.target.value)} value="1" type="radio" name="loginradio"/>&nbsp;Full Names</label></Col></Row>
                        <Row><Col xs='12'><label><input checked={loginNameRadio === '2'} onChange={(e)=>setLoginNameRadio(e.target.value)} value="2" type="radio" name="loginradio"/>&nbsp;First Names</label></Col></Row>
                        <Row><Col xs='12'><label><input checked={loginNameRadio === '3'} onChange={(e)=>setLoginNameRadio(e.target.value)} value="3" type="radio" name="loginradio"/>&nbsp;Last Names</label></Col></Row>
                        <Row><Col xs='12'><label><input checked={loginNameRadio === '4'} onChange={(e)=>setLoginNameRadio(e.target.value)} value="4" type="radio" name="loginradio"/>&nbsp;First Name + First Letter of Last Name</label></Col></Row>
                        <Row><Col xs='12'>&nbsp;</Col></Row>
                        </Col>
                    </Row>
                    <Row><Col xs='12'>&nbsp;</Col></Row>
                </Col>

                <Col xs='4'>
                    <TitleBar>
                        <Col style={{textAlign: 'left', color: 'white' }} xs='8'><h3>Passwords</h3></Col>
                    </TitleBar>

                    <Row style={{height:'228px',backgroundColor:'#efefff', borderStyle: 'solid', borderWidth: '1px', borderColor: '#bfbfbf', paddingLeft:'10px'}}>
                        <Col xs='12'>
                            <Row><Col xs='12'>&nbsp;</Col></Row>
                            <Row style={{textAlign: 'center'}}>
                                <Col xs='12'>
                                <label><input checked={passwordsRadio === '1'} onChange={(e)=>setPasswordsRadio(e.target.value)} value="1" type="radio" name="passradio"/>&nbsp;Generated</label>&nbsp;&nbsp;&nbsp;
                                <label><input checked={passwordsRadio === '2'} onChange={(e)=>setPasswordsRadio(e.target.value)} value="2" type="radio" name="passradio"/>&nbsp;Single</label>&nbsp;&nbsp;&nbsp;
                                <label><input checked={passwordsRadio === '3'} onChange={(e)=>setPasswordsRadio(e.target.value)} value="3" type="radio" name="passradio"/>&nbsp;None</label></Col>
                            </Row>
                            <Row><Col xs='12'>&nbsp;</Col></Row>
                            {(passwordsRadio === '1')&&<>
                                <Row>                   
                                    <Col xs='12' className="form-group">
                                        <label style={{float:'left', marginRight:'5px', marginTop:'5px'}}>Number of Characters:</label>&nbsp;&nbsp;
                                        <input type="text" size="4" onChange={(e)=>setPasswordsNumChars(e.target.value)} value={passwordsNumChars}/>
                                    </Col>
                                </Row> 
                                <Row><Col xs='12'>&nbsp;</Col></Row>
                                <Row style={{textAlign: 'center'}}>                   
                                    <Col xs='6'>
                                        <input checked={useLetters} onChange={(e)=>setUseLetters(e.target.checked)} type="checkbox" className="form-check-input" /> <label htmlFor="name">Use Letters</label>
                                    </Col>
                                    <Col xs='6'>
                                        <input checked={useNumbers} onChange={(e)=>setUseNumbers(e.target.checked)} type="checkbox" className="form-check-input" /> <label htmlFor="name">Use Numbers</label>
                                    </Col>
                                </Row> 
                            </>}

                            {(passwordsRadio === '2')&&
                                <Row>                   
                                    <Col xs='12' className="form-group">
                                        <center><label style={{float:'left', marginRight:'5px', marginTop:'5px'}}>Password:</label><br/>
                                        <input type="text" onChange={(e)=>setPasswordsDefault(e.target.value)} value={passwordsDefault}/></center>
                                    </Col>
                                </Row>
                            }                        
                        </Col>
                    </Row>
                    <Row><Col xs='12'>&nbsp;</Col></Row>
                </Col>
            </Row> 

            <Row>
                <Col xs='12'>
                    <Button onClick={()=>setStep('2')} variant='danger'>Back</Button> &nbsp;
                    <Button onClick={verifyClicked} variant="success">Verify</Button> 
                </Col>
            </Row>    
            <br/>
        </>}
        {(step==='4') && <>

            <Row><Col xs='12'>
                <Alert variant='warning'>
                <h4> Step 4 ) </h4>
                <p> Look through the list of classes and students for conflicts and problem areas.  Once satisfied press the {'"Import Students"'}.</p>
                </Alert>    
            </Col></Row>
            <span style={{width:'30px',height:'30px', backgroundColor:'lightblue', borderStyle: 'solid', borderWidth: '1px'}}>&nbsp;&nbsp;&nbsp;&nbsp;</span> Class Ok &nbsp;
            <span style={{width:'30px',height:'30px', backgroundColor:'lightgreen', borderStyle: 'solid', borderWidth: '1px'}}>&nbsp;&nbsp;&nbsp;&nbsp;</span> Student Ok &nbsp;
            <span style={{width:'30px',height:'30px', backgroundColor:'#FFFFAF', borderStyle: 'solid', borderWidth: '1px'}}>&nbsp;&nbsp;&nbsp;&nbsp;</span> Will merge with existing class &nbsp;
            <span style={{width:'30px',height:'30px', backgroundColor:'#FFAFAF', borderStyle: 'solid', borderWidth: '1px'}}>&nbsp;&nbsp;&nbsp;&nbsp;</span> Has Error &nbsp;<br/>
            <hr/>
            <Row><Col xs='12'>
            <div style={{overflowY:'scroll', overflowX : 'hidden',height:'300px', padding:'10px', borderBottom: '1px solid #cfcfcf', borderLeft: '1px solid #cfcfcf', borderRight: '1px solid #cfcfcf'}}>
                    {titleRow}
                    {newStudents.map((classRec, i_class) => <span key={i_class}>
                        <VerifyRow data={classRec} type={'class'} /> 
                        {classRec.students.map((studentRec, i_stud) => 
                            <VerifyRow key={i_stud} data={studentRec} type={'student'} /> 
                        )}    
                    </span>
                    )}
                </div>
            </Col></Row>

            <Row>
                <Col xs='12'>
                    <Button onClick={()=>{
                        if(teacherRadio==='1') setStep('3');
                        if(teacherRadio==='2') setStep('2');
                        if(teacherRadio==='3') setStep('2');
                        if(teacherRadio==='4') setStep('3');
                        if(teacherRadio==='6') setStep('2');
                    }} variant="danger">Back</Button> &nbsp;
                    <Button onClick={saveClasses} variant="success">Create Classes and Students</Button> 
                    {(numErrors>0) && <span style={{color:'red'}}>&nbsp; {numErrors} Errors found (Errors will not be included)</span> }
                </Col>
            </Row> 
        </>}
    </div> 
  );
};
const classColor = 'lightblue';
const studentColor = '#BFBFFF';
const loginColor = 'BFFFBF';
const passwordColor = '#FFBFBF';
const colors1 = [classColor, studentColor, studentColor, studentColor, studentColor, studentColor];
const colors2 = [classColor, studentColor, loginColor, classColor, studentColor, loginColor];
const colors3 = [classColor, studentColor, loginColor, passwordColor, studentColor, loginColor, passwordColor];

const ImportRow1 = ({dataLine}) => <tr>
        <td style={{backgroundColor: classColor, border: '1px solid black'}}> {dataLine[0]}</td>
        <td style={{backgroundColor: studentColor, border: '1px solid black'}}> {dataLine[1]}</td>
        <td style={{backgroundColor: studentColor, border: '1px solid black'}}> {dataLine[2]}</td>
        <td style={{backgroundColor: studentColor, border: '1px solid black'}}> {dataLine[3]}</td>
        <td style={{backgroundColor: studentColor, border: '1px solid black'}}> {dataLine[4]}</td>
    </tr>;

const ImportRow2 = ({dataLine}) => <tr>
        <td style={{backgroundColor: classColor, border: '1px solid black'}}> {dataLine[0]}</td>
        <td style={{backgroundColor: loginColor, border: '1px solid black'}}> {dataLine[1]}</td>
        <td style={{backgroundColor: passwordColor, border: '1px solid black'}}> {dataLine[2]}</td>
        <td style={{backgroundColor: studentColor, border: '1px solid black'}}> {dataLine[3]}</td>
        <td style={{backgroundColor: loginColor, border: '1px solid black'}}> {dataLine[4]}</td>
        <td style={{backgroundColor: passwordColor, border: '1px solid black'}}> {dataLine[5]}</td>
    </tr>;

const ImportRow3 = ({dataLine}) => <tr>
        <td style={{backgroundColor: classColor, border: '1px solid black'}}> {dataLine[0]}</td>
        <td style={{backgroundColor: studentColor, border: '1px solid black'}}> {dataLine[1]}</td>
        <td style={{backgroundColor: loginColor, border: '1px solid black'}}> {dataLine[2]}</td>
        <td style={{backgroundColor: passwordColor, border: '1px solid black'}}> {dataLine[3]}</td>
        <td style={{backgroundColor: studentColor, border: '1px solid black'}}> {dataLine[4]}</td>
    </tr>;   

const ImportRow4 = ({dataLine,i}) => <tr>
        <td style={{backgroundColor: colors1[i],border: '1px solid black'}}> {dataLine[0]}</td>
        <td style={{backgroundColor: colors1[i],border: '1px solid black'}}> {dataLine[1]}</td>
        <td style={{backgroundColor: colors1[i],border: '1px solid black'}}> {dataLine[2]}</td>
        <td style={{backgroundColor: colors1[i],border: '1px solid black'}}> {dataLine[3]}</td>
        <td style={{backgroundColor: colors1[i],border: '1px solid black'}}> {dataLine[4]}</td>
    </tr>;  

const ImportRow5 = ({dataLine,i}) => <tr>
        <td style={{backgroundColor: colors2[i],border: '1px solid black'}}> {dataLine[0]}</td>
        <td style={{backgroundColor: colors2[i],border: '1px solid black'}}> {dataLine[1]}</td>
        <td style={{backgroundColor: colors2[i],border: '1px solid black'}}> {dataLine[2]}</td>
        <td style={{backgroundColor: colors2[i],border: '1px solid black'}}> {dataLine[3]}</td>
        <td style={{backgroundColor: colors2[i],border: '1px solid black'}}> {dataLine[4]}</td>
    </tr>; 

const ImportRow6 = ({dataLine,i}) => <tr>
        <td style={{backgroundColor: colors3[i],border: '1px solid black'}}> {dataLine[0]}</td>
        <td style={{backgroundColor: colors3[i],border: '1px solid black'}}> {dataLine[1]}</td>
        <td style={{backgroundColor: colors3[i],border: '1px solid black'}}> {dataLine[2]}</td>
        <td style={{backgroundColor: colors3[i],border: '1px solid black'}}> {dataLine[3]}</td>
        <td style={{backgroundColor: colors3[i],border: '1px solid black'}}> {dataLine[4]}</td>
    </tr>; 

const verifyColor = (type, error) =>{    
    if (error==='Merging Class') return {backgroundColor:'#FFFFAF'};
    if (error!=='ok') return {backgroundColor:'#FFAFAF'};
    if(type==='class') return {backgroundColor:'lightblue'};
    if(type==='student') return {backgroundColor:'lightgreen'};
};

const VerifyRow = ({data, type}) => <Row style={verifyColor(type, data.type)} >
        <Col style={{textAlign: 'left'}} xs='3'> {(data.type!=='ok' && data.type!=='Merging Class')?<span style={{color:'red'}}><IconClose/></span>:<span style={{color:'green'}}><IconCheck/></span>} {data.name}</Col>
        <Col style={{textAlign: 'left'}} xs='3'>{data.login}</Col>
        <Col style={{textAlign: 'left'}} xs='3'>{data.pass}</Col>
        <Col style={{textAlign: 'left'}} xs='3'>{data.type}</Col>
    </Row>;

ImportUsersComp.propTypes = {
    pageState: PropTypes.object
};

export default ImportUsersComp;